import { UnicodeEntity } from '@mews/enums';
import { LocalizedEnumify, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Typography, Body, Stack } from '@optimus-web/core';
import { ServiceOrderNote } from '@mews-commander/types';
import { LocalizedDateTimeFromUtc } from '@mews-commander/ui';
import { getNoteLinesFormatted } from '@mews-commander/utils';
import { getNoteLabelEnumValue } from '../../PropertiesTab/NotesForm/utils';

interface Props {
    note: ServiceOrderNote;
}

const NoteMetadata = ({ note }: Props) => (
    <Typography textStyle="bodySmall" variant="secondary" as="div">
        <LocalizedText textKey={TextKey.Note} />
        {UnicodeEntity.NoBreakSpace}
        {UnicodeEntity.LeftParenthesis}
        <LocalizedEnumify enumValue={getNoteLabelEnumValue(note)} />
        {UnicodeEntity.RightParenthesis}
        {UnicodeEntity.Comma}
        {UnicodeEntity.NoBreakSpace}
        <LocalizedDateTimeFromUtc utcString={note.createdUtc} />
    </Typography>
);

const NotesListItem: React.FC<Props> = ({ note }) => {
    if (!note.text) {
        return null;
    }

    return (
        <Stack vertical data-test-smart-detail-note={note.id}>
            <Body size="small" wordBreak="break-word">
                {getNoteLinesFormatted(note)}
            </Body>
            <NoteMetadata note={note} />
        </Stack>
    );
};

export default NotesListItem;
